var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaransaviLeft1Halateh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,15.8c-0.1,0-0.2,0-0.3-0.1L0.6,1.3C0.4,1.1,0.4,0.8,0.6,0.6C0.7,0.4,1,0.4,1.2,0.6l17.1,14.4 c0.2,0.2,0.2,0.5,0.1,0.7C18.3,15.7,18.2,15.8,18,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9,29.3c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l17.1-13.5c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7L1.2,29.2C1.1,29.2,1,29.3,0.9,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29h28V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,26.5h-14V3.2h14V26.5z M4.4,25.6h12.3V4.1H4.4V25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,26.8h-4.5V3.1h4.5V26.8z M23.8,25.8h2.6V4.1h-2.6V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,29.7c-0.3,0-0.5-0.2-0.5-0.5V0.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.3 C20.4,29.5,20.2,29.7,19.9,29.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 11.3,
    width: 3.5,
    height: 8.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaransaviLeft1Halateh);
export default __webpack_public_path__ + "static/media/faransavi_left_1halateh.ea06776a2a4369a941ef0a05745c23dd.svg";
export { ForwardRef as ReactComponent };